module.exports = __webpack_public_path__ + "fonts/uCL3TdEd.woff";